import React, {useState} from 'react';
import * as Yup from 'yup';
import {Formik} from "formik";
import {FormGroup, Input, Label, Button, Alert, FormText, FormFeedback} from "reactstrap";
import {isUserAuthenticated} from "../services/auth";
import api from "../services/api";
import {Link, Redirect, useHistory} from "react-router-dom";


const ResetPassword = () => {
    const history = useHistory();
    const [alert, setAlert] = useState(null);

    const initialValues = {
        email: "",
        token: history.location.state.passwordResetToken,
        new_password: ""
    };

    const validationSchema = Yup.object().shape({
        email: Yup.string().required(),
        new_password: Yup.string().required('New password is a required field')
        .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#\-\_\$%\^.,])(?=.*[0-9]).{8,}$/, 'Password should be at least 8 characters long, include a special character (e.g., !@#-_$%^), AND at least one upper/lower case letter.')
    });

    const handleRedirectToLogin = () => {
        window.location = window.location.href.split('?')[0];
    };

    const onSubmit = (values, setSubmitting) => {
        setAlert({message: "", type: ""});

        api.resetPassword(values).then(() => {
            setAlert({
                message: "Password has been reset successfully. You will be redirected to login page.",
                type: "success"
            });
            setTimeout(() => handleRedirectToLogin(), 3000);
        }).catch(() => {
            setAlert({
                message: (
                    <React.Fragment>
                        This link to reset your password has expired. Please{' '}
                        <Link to="/forget-password">click here</Link>{' '}
                        to receive a new link. If the issue persists, please call our Support Team for
                        assistance at (877) 247-8817. You may also email us at{' '}
                        <a href="mailto:enroll@hubinternational.com">enroll@hubinternational.com</a>.
                    </React.Fragment>
                ),
                type: "danger"
            });
        }).finally(() => setSubmitting(false))
    };

    if (isUserAuthenticated()) {
        return <Redirect to="/enrollment"/>
    }

    return (
        <React.Fragment>
            <h1 className="page-header elementor-heading-title elementor-size-large">Reset Password</h1>

            <div className="elementor-divider"><span className="elementor-divider-separator"/></div>

            {alert &&
            <Alert isOpen={!!alert.message} color={alert.type}>
                {alert.message}
            </Alert>}

            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={(values, {setSubmitting}) => onSubmit(values, setSubmitting)}
            >
                {(
                    {values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting}
                ) => (
                    <form onSubmit={handleSubmit} className="mb-3">
                        <FormGroup>
                            <Label for="email">Email</Label>
                            <Input type="email" name="email" id="email"
                                   onChange={handleChange}
                                   onBlur={handleBlur}
                                   value={values.email}
                                   invalid={!!(errors.email && touched.email && errors.email)}
                            />
                        </FormGroup>

                        <FormGroup>
                            <Label for="new-password">New Password</Label>
                            <Input type="password" name="new_password" id="new-password"
                                   onChange={handleChange}
                                   onBlur={handleBlur}
                                   value={values.new_password}
                                   invalid={!!(errors.new_password && touched.new_password)}
                                   autoComplete="new-password"
                            />
                            <FormFeedback>{errors?.new_password}</FormFeedback>
                        </FormGroup>

                        <Button type="submit" disabled={isSubmitting} className="elementor-button mb-3">
                            Submit
                        </Button>
                    </form>
                )}
            </Formik>
        </React.Fragment>
    );
};

export default ResetPassword;
